import { Grid } from "@sidelinesports/fan-design-system";
import { SlideoutPanel } from "../../../../components/index.tsx";
import { FeaturedMessages } from "./FeaturedMessages.tsx";
import { LiveFeedMessages } from "./LiveFeedMessages.tsx";
import { LiveFeedPanelHeader } from "./LiveFeedPanelHeader.tsx";
import { LiveFeedTriggerButton } from "./LiveFeedTriggerButton.tsx";

export const LiveFeedSection = () => {
  return (
    <SlideoutPanel.Root>
      <SlideoutPanel.Trigger as={LiveFeedTriggerButton} />
      <SlideoutPanel.Content name="Live Feed">
        <Grid gap={16}>
          <LiveFeedPanelHeader />
          <FeaturedMessages />
          <LiveFeedMessages />
        </Grid>
      </SlideoutPanel.Content>
    </SlideoutPanel.Root>
  );
};
